exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reset-modal-title-override {\n    font-size: 14px !important;\n}\n\n.form-group-override {\n    padding-left: 130px !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/account/password/password.component.css
// module id = 463
// module chunks = 0